import * as React from 'react';
import './link.scss';

let classNames = require('classnames');

function Link({ customClass, href, label, target = '_self', children, ariaLabel }) {
  return (
    <a className={classNames(['links', customClass])} href={href} target={target} aria-label={ariaLabel}>{children || label}</a>
  );
}

export default Link;
